import service from '@/store/services/client_analytics-service';

const state = {
    clientAnalytics: {},
    sendUplChunk:{}
};

const mutations = {
    SET_CLIENT_ANALYTICS: (state, clientAnalytics) => {
        state.clientAnalytics = clientAnalytics;
    },
    SET_SEND_UPL_CHUNK: (state, sendUplChunk) => {
        state.clientAnalytics = sendUplChunk;
    },
};

const actions = {
    clientAnalytics({commit, dispatch}, params) {
        return service.getClientAnalytics(params)
            .then(({clientAnalytics}) => {
                commit('SET_CLIENT_ANALYTICS', clientAnalytics);
            });
    },
    sendUplChunk({commit, dispatch}, params) {
        return service.sendUplChunk(params)
            .then((sendUplChunk) => {
                commit('SET_SEND_UPL_CHUNK', sendUplChunk);
            });
    },

};

const getters = {
    adminReportsList: state => state.adminReportsList,
    adminDayReport: state => state.adminDayReport,
    clientAnalytics: state => state.clientAnalytics,
    sendUplChunk: state => state.sendUplChunk,
};

const adminReport = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default adminReport;